import React from 'react';

import Image from '@atlaskit/image';

import AnalyzeIcon from '../../assets/analyze-icon.svg';
import BrainstormIcon from '../../assets/brainstorm-icon.svg';
import CreateIcon from '../../assets/create-icon.svg';
import ExecuteIcon from '../../assets/execute-icon.svg';
import FindIcon from '../../assets/find-icon.svg';
import GeneralPromptIcon from '../../assets/general-prompt-icon.svg';
import LearnIcon from '../../assets/learn-icon.svg';
import ReviewIcon from '../../assets/review-icon.svg';
import SummarizeIcon from '../../assets/summarize-icon.svg';
import { type PromptCategory } from '../prompt-cards';

type IconComponent = () => JSX.Element;

const createIcon =
	(src: string): IconComponent =>
	() =>
		React.createElement(Image, { src, alt: '' });

const defaultIcon = createIcon(GeneralPromptIcon);

const iconMap = {
	Analyze: createIcon(AnalyzeIcon),
	Brainstorm: createIcon(BrainstormIcon),
	Review: createIcon(ReviewIcon),
	Summarize: createIcon(SummarizeIcon),
	Create: createIcon(CreateIcon),
	Execute: createIcon(ExecuteIcon),
	Find: createIcon(FindIcon),
	Learn: createIcon(LearnIcon),
} as const;

export const getUseCaseIcon = (useCase: PromptCategory | undefined) => {
	if (useCase === undefined || !(useCase in iconMap)) {
		return defaultIcon;
	}
	return iconMap[useCase as keyof typeof iconMap];
};
